import { assets } from '@/assets';
import type { DiagramId } from '@/game/coach/cues';
import type { MouthDiagram } from '@/ui/MouthHintCard';
import { strings } from './strings';

/**
 * Mouth diagrams for the placement cues, restyled from Wikimedia Commons and OpenStax originals
 * (provenance in art/README.md).
 */
export const DIAGRAMS: Record<DiagramId, MouthDiagram> = {
  'r-bunched': {
    image: assets.coach.rBunched,
    alt: strings.hint.diagrams['r-bunched'],
    look: strings.hint.look['r-bunched'],
    pose: 'rBunched',
  },
  'r-retroflex': {
    image: assets.coach.rRetroflex,
    alt: strings.hint.diagrams['r-retroflex'],
    look: strings.hint.look['r-retroflex'],
    pose: 'rRetroflex',
  },
  w: { image: assets.coach.w, alt: strings.hint.diagrams.w, look: strings.hint.look.w, pose: 'w' },
  l: { image: assets.coach.l, alt: strings.hint.diagrams.l, look: strings.hint.look.l, pose: 'l' },
  'tongue-sides': {
    image: assets.coach.tongueSides,
    alt: strings.hint.diagrams['tongue-sides'],
    look: strings.hint.look['tongue-sides'],
    tongueSides: true,
  },
};
